export const getStageByImage = (stages, image) => {
    let neededStage = null;
    stages.forEach(function(stage) {
        stage.markers.forEach(function(marker) {
            if (marker.file_name === image) {
                neededStage = stage;
            }
        }, this);
    }, this);

    if (neededStage) {
        return neededStage;
    }

    return null;
}